/**
 * Canonical pricing values.
 *
 * The `Offer` in SoftwareApplication JSON-LD is a machine-readable price claim
 * that Google can surface in results, so it must not be able to drift from what
 * the site actually charges. It previously hardcoded '5.00' independently of
 * every other mention of the price.
 *
 * Marketing prose still spells the price out inline, because interpolating it
 * mid-sentence hurts readability for no benefit. What matters is that the
 * structured data and the headline figure share one source.
 */

/** Monthly price per connected Gmail mailbox, in USD. */
export const MONTHLY_PRICE_USD = 5;

/** ISO 4217 currency for {@link MONTHLY_PRICE_USD}. */
export const PRICE_CURRENCY = 'USD';

/** Length of the free trial, in days. */
export const TRIAL_DAYS = 14;

/**
 * Price formatted for schema.org `Offer.price` (decimal string, no symbol).
 *
 * @example '5.00'
 */
export const MONTHLY_PRICE_SCHEMA = MONTHLY_PRICE_USD.toFixed(2);

/**
 * Price formatted for display.
 *
 * @example '$5'
 */
export const MONTHLY_PRICE_DISPLAY = `$${MONTHLY_PRICE_USD}`;
